<template>
  <div class="container pt-0">
    <inscription-datatable />
  </div>
</template>

<script>
import InscriptionDatatable from "./inscription_datatable/Index.vue";

export default {
  name: "StudentInscriptions",
  components: { InscriptionDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
